import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "my-2 flex flex-col gap-y-2" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_3 = { class: "flex justify-between items-start gap-6" }
const _hoisted_4 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_5 = { class: "flex flex-col items-end gap-2 w-40" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = { class: "flex items-center w-full ml-auto justify-between gap-x-6 pr-4 font-montserrat" }
const _hoisted_8 = { class: "flex flex-col gap-y-1" }
const _hoisted_9 = { class: "flex items-center gap-x-2 text-black-lp-100 font-semibold text-base" }
const _hoisted_10 = { class: "font-normal" }
const _hoisted_11 = { class: "text-sm font-normal" }
const _hoisted_12 = { class: "flex items-center justify-end gap-x-6" }
const _hoisted_13 = { class: "flex flex-col gap-y-1 text-right" }
const _hoisted_14 = { class: "text-base text-right font-bold" }
const _hoisted_15 = { class: "text-green-lp-400" }
const _hoisted_16 = { class: "text-gray-lp-800" }
const _hoisted_17 = { class: "flex flex-col gap-y-1 text-right" }
const _hoisted_18 = { class: "text-base text-right font-bold text-red-lp-100" }
const _hoisted_19 = { class: "m-0 font-montserrat flex flex-col gap-y-3" }
const _hoisted_20 = { class: "overflow-hidden rounded-xl border border-gray-lp-1400" }
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = /*#__PURE__*/_createVNode("thead", { class: "bg-gray-lp-1000 text-sm font-bold border-b border-gray-lp-1400" }, [
  /*#__PURE__*/_createVNode("th", { class: "rounded-tl-xl py-2.5 w-3/12" }, [
    /*#__PURE__*/_createVNode("span", { class: "px-3 flex justify-start" }, " Nama Produk ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-2/12" }, [
    /*#__PURE__*/_createVNode("span", { class: "border-l border-gray-lp-600 px-3 flex justify-start" }, " Total item ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-2/12" }, [
    /*#__PURE__*/_createVNode("span", { class: "border-l border-gray-lp-600 px-3 flex justify-start" }, " Harga satuan ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "py-2.5 w-3/12" }, [
    /*#__PURE__*/_createVNode("span", { class: "border-l border-gray-lp-600 px-3 flex justify-start" }, " Total yang dibeli ")
  ]),
  /*#__PURE__*/_createVNode("th", { class: "rounded-tr-xl py-2.5 w-2/12" }, [
    /*#__PURE__*/_createVNode("span", { class: "border-l border-gray-lp-600 px-3 flex justify-end" }, " Subtotal ")
  ])
], -1)
const _hoisted_23 = { class: "text-left px-3 py-3" }
const _hoisted_24 = { class: "flex items-center gap-2" }
const _hoisted_25 = { class: "text-base" }
const _hoisted_26 = { class: "text-left px-3 py-3" }
const _hoisted_27 = { class: "text-left px-3 py-3" }
const _hoisted_28 = { class: "text-left px-3 py-3" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "flex items-center gap-x-3"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "w-3 pi pi-minus" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "w-3 pi pi-plus" }, null, -1)
const _hoisted_33 = { class: "flex items-center gap-x-1.5 relative" }
const _hoisted_34 = { class: "text-right px-3 py-3 font-semibold" }
const _hoisted_35 = {
  key: 0,
  class: "flex items-center gap-x-4 justify-end"
}
const _hoisted_36 = { class: "flex items-center gap-x-1.5 relative" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  for: "allStockEmpty",
  class: "text-sm text-black-lp-100 relative"
}, " Semua stok habis ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ModalUpdateOrder = _resolveComponent("ModalUpdateOrder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skeletonCount, (n) => {
            return (_openBlock(), _createBlock("div", {
              key: n,
              class: "rounded-xl border border-gray-lp-1400 bg-white p-4 flex flex-col gap-4 animate-pulse"
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Skeleton, {
                    height: "18px",
                    width: "35%"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "14px",
                    width: "55%"
                  })
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Skeleton, {
                    height: "16px",
                    width: "80%"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "16px",
                    width: "60%"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
                  return _createVNode(_component_Skeleton, {
                    key: i,
                    height: "32px",
                    width: "100%"
                  })
                }), 64))
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_Accordion, {
          key: 1,
          id: "accordion-kulioner-merchant",
          multiple: "",
          activeIndex: [0],
          class: "flex flex-col gap-y-2"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.modelValue, (item, index) => {
              return (_openBlock(), _createBlock(_component_AccordionTab, {
                key: item.id
              }, {
                header: _withCtx(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _createTextVNode(_toDisplayString(item.name) + " ", 1),
                        _createVNode("span", _hoisted_10, " (" + _toDisplayString(item.phoneNumber) + ") ", 1),
                        _createVNode(_component_Badge, {
                          id: "merchant-badge",
                          value: _ctx.getBadgeStatus(_ctx.merchantData[index]).label,
                          severity: _ctx.getBadgeStatus(_ctx.merchantData[index]).severity
                        }, null, 8, ["value", "severity"])
                      ]),
                      _createVNode("span", _hoisted_11, [
                        _createTextVNode(_toDisplayString(item.address) + " ", 1),
                        _createVNode("a", {
                          href: `https://www.google.com/maps?q=${item.latLon}`,
                          class: "text-red-lp-100 underline font-semibold",
                          target: "_blank",
                          onClick: _cache[1] || (_cache[1] = $event => $event.stopPropagation())
                        }, _toDisplayString(_ctx.$t("kulioner.merchant.seeLocation")), 9, ["href"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t("kulioner.merchant.summary.totalItem")), 1),
                        _createVNode("span", _hoisted_14, [
                          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.computeKulionerTotals([_ctx.merchantData[index]]).totalActualPieces), 1),
                          _createVNode("span", _hoisted_16, "/" + _toDisplayString(_ctx.computeKulionerTotals([_ctx.merchantData[index]]).totalPieces), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_17, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t("kulioner.merchant.summary.totalTransaction")), 1),
                        _createVNode("span", _hoisted_18, _toDisplayString(_ctx.formatPriceRP(
                      _ctx.computeKulionerTotals([_ctx.merchantTransaction[index]]).totalTransactionCompleted
                    )), 1)
                      ]),
                      _createVNode("button", {
                        class: "border border-red-lp-100 rounded-md p-2.5 flex items-center justify-center pointer-events-auto",
                        onClick: ($event: any) => (_ctx.onPrintReceipt($event, item))
                      }, [
                        _createVNode(_component_Icons, {
                          name: "download-new",
                          class: "w-4 text-red-lp-100"
                        })
                      ], 8, ["onClick"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("table", _hoisted_21, [
                        _hoisted_22,
                        _createVNode("tbody", {
                          class: {
                  'bg-gray-lp-1000': item.isPurchased
                }
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.products, (product, index) => {
                            return (_openBlock(), _createBlock("tr", {
                              key: index,
                              class: "border-t border-gray-lp-200"
                            }, [
                              _createVNode("td", _hoisted_23, [
                                _createVNode("div", _hoisted_24, [
                                  (product.thumbnail)
                                    ? (_openBlock(), _createBlock("img", {
                                        key: 0,
                                        src: `${product.thumbnail}`,
                                        class: "w-8 h-8 object-cover rounded-md",
                                        alt: `Product ${product.name}`
                                      }, null, 8, ["src", "alt"]))
                                    : _createCommentVNode("", true),
                                  _createVNode("p", _hoisted_25, _toDisplayString(product.name), 1)
                                ])
                              ]),
                              _createVNode("td", _hoisted_26, _toDisplayString(product.quantity), 1),
                              _createVNode("td", _hoisted_27, _toDisplayString(_ctx.formatPriceRP(product.price)), 1),
                              _createVNode("td", _hoisted_28, [
                                (item.isPurchased)
                                  ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(product.actualQuantity), 1))
                                  : (_openBlock(), _createBlock("div", _hoisted_30, [
                                      _createVNode("div", {
                                        class: ["flex max-w-max items-center gap-x-2 rounded-lg border border-gray-lp-2100 px-3 py-2", [
                          {
                            'bg-gray-lp-100':
                              _ctx.status !== 'ORDPRC' || product.isQuantityUpdated
                          }
                        ]]
                                      }, [
                                        _createVNode("button", {
                                          class: {
                            'text-red-lp-100': product.actualQuantity,
                            'text-gray-lp-600 cursor-not-allowed':
                              _ctx.status !== 'ORDPRC' ||
                              !product.actualQuantity ||
                              product.isQuantityUpdated
                          },
                                          onClick: ($event: any) => (_ctx.onDecrease(product)),
                                          disabled: 
                            !product.actualQuantity ||
                              _ctx.status !== 'ORDPRC' ||
                              product.isQuantityUpdated
                          
                                        }, [
                                          _hoisted_31
                                        ], 10, ["onClick", "disabled"]),
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": ($event: any) => (product.actualQuantity = $event),
                                          disabled: 
                            _ctx.status !== 'ORDPRC' || product.isQuantityUpdated
                          ,
                                          onInput: ($event: any) => (_ctx.onInputQuantity($event, product)),
                                          placeholder: "0",
                                          class: ["w-8 outline-none text-center", [
                            {
                              'text-gray-lp-600 cursor-not-allowed':
                                _ctx.status !== 'ORDPRC' || product.isQuantityUpdated
                            }
                          ]]
                                        }, null, 42, ["onUpdate:modelValue", "disabled", "onInput"]), [
                                          [_vModelText, product.actualQuantity]
                                        ]),
                                        _createVNode("button", {
                                          class: {
                            'text-red-lp-100': product.actualQuantity,
                            'text-gray-lp-600 cursor-not-allowed':
                              _ctx.status !== 'ORDPRC' ||
                              product.actualQuantity >= product.quantity ||
                              product.isQuantityUpdated
                          },
                                          onClick: ($event: any) => (_ctx.onIncrease(product)),
                                          disabled: 
                            _ctx.status !== 'ORDPRC' ||
                              product.actualQuantity >= product.quantity ||
                              product.isQuantityUpdated
                          
                                        }, [
                                          _hoisted_32
                                        ], 10, ["onClick", "disabled"])
                                      ], 2),
                                      _createVNode("div", _hoisted_33, [
                                        _createVNode(_component_Checkbox, {
                                          class: "kulioner-product-stock-empty",
                                          modelValue: 
                            product.actualQuantity === 0 && product.stockEmpty
                          ,
                                          inputId: `stockEmpty-${index}`,
                                          binary: true,
                                          disabled: 
                            _ctx.status !== 'ORDPRC' || product.isQuantityUpdated
                          ,
                                          "onUpdate:modelValue": ($event: any) => (
                            _ctx.onUpdateStockEmpty($event, product)
                          )
                                        }, null, 8, ["modelValue", "inputId", "disabled", "onUpdate:modelValue"]),
                                        _createVNode("label", {
                                          for: `stockEmpty-${index}`,
                                          class: "text-sm text-black-lp-100"
                                        }, " Stok habis ", 8, ["for"])
                                      ])
                                    ]))
                              ]),
                              _createVNode("td", _hoisted_34, _toDisplayString(_ctx.formatPriceRP(product.price * product.actualQuantity)), 1)
                            ]))
                          }), 128))
                        ], 2)
                      ])
                    ]),
                    (_ctx.status === 'ORDPRC' && !item.isPurchased)
                      ? (_openBlock(), _createBlock("div", _hoisted_35, [
                          _createVNode("div", _hoisted_36, [
                            _createVNode(_component_Checkbox, {
                              "model-value": _ctx.isAllStockEmpty(item),
                              "onUpdate:modelValue": ($event: any) => (_ctx.onSetAllStockEmpty($event, item, index)),
                              inputId: "allStockEmpty",
                              binary: true
                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                            _hoisted_37
                          ]),
                          _createVNode(_component_LpButton, {
                            color: "red-lp-100",
                            textColor: "white",
                            title: "Update pesanan",
                            onClick: ($event: any) => (_ctx.onOpenUpdateMerchantOrder(item))
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createVNode(_component_ModalUpdateOrder, {
      modelValue: _ctx.openDownload,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDownload = $event)),
      merchantData: _ctx.selectedMerchant,
      summaryData: _ctx.summaryMerchant,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDownload = false)),
      onAction: _ctx.onDownload
    }, null, 8, ["modelValue", "merchantData", "summaryData", "onAction"])
  ]))
}